import React, { useEffect, useState } from "react";

import { useTableContext } from "../../context/TableContext";
import useFetchData from "../../hooks/useFetchData";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import { getToolTipAttributes } from "../../utils/tooltip";
import MaterialIcon from "../BuilderComponents/MaterialIcon";
import TableTreeModal from "../BuilderComponents/TableTreeModal";
import Input from "../FormComponents/Input";

const initModalState = {
  isOpen: false,
  fieldId: null,
  index: null
};
const EditReactComponent = ({ editElementData, setEditElementData, tableType, tableId }) => {
  const { getTableTypeData } = useTableContext();
  const { data, loading, error } = useFetchData(`/custom-component/${editElementData.id}`);
  const [mapping, setMapping] = useState([]);
  const [modalState, setModalState] = useState(initModalState);
  // const allFieldsObject = useRef({});
  const [allFieldsObject, setAllFieldsObject] = useState({});
  const openModal = (index, fieldId) => setModalState({ isOpen: true, fieldId, index });
  const closeModal = () => setModalState(initModalState);

  useEffect(() => {
    if (data) {
      const extactProps = async () => {
        const propList = data.props || [];
        const savedPropList = editElementData.props_mapping || [];

        const savedMap = new Map(savedPropList.map((item) => [item.key, item]));
        const mapping = propList.map((prop) => {
          const saved = savedMap.get(prop.name);
          return {
            key: prop.name,
            value: saved?.value || "",
            type: saved?.type || "mapped" // default to "mapped" if not present
          };
        });

        setMapping(mapping);

        const { tableObject } = await getTableTypeData(tableType, tableId);
        setAllFieldsObject(tableObject);
      };

      extactProps();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const handleChangeMappingValue = (index, value) => {
    const newMapping = [...mapping];
    newMapping[index].value = value;
    setMapping(newMapping);
    const finalMapping = filterAndTrimMappingEntries(mapping);
    setEditElementData({ ...editElementData, props_mapping: finalMapping });
  };

  const handleChangeField = (field) => {
    handleChangeMappingValue(modalState.index, field.id);
    closeModal();
  };
  const removeMappedValue = (index) => {
    const newMapping = [...mapping];
    newMapping[index] = {
      ...newMapping[index],
      value: ""
    };

    setMapping(newMapping);

    const finalMapping = filterAndTrimMappingEntries(newMapping);
    setEditElementData({ ...editElementData, props_mapping: finalMapping });
  };

  const changeMapType = (index, type) => {
    const newMapping = [...mapping];
    newMapping[index].type = type;
    newMapping[index].value = "";
    setMapping(newMapping);
    const finalMapping = filterAndTrimMappingEntries(mapping);
    setEditElementData({ ...editElementData, props_mapping: finalMapping });
  };
  return (
    <>
      <div>
        <div className="">
          <table className="post_activity_sidebar_table">
            <thead>
              <tr>
                <th>Key</th>
                <th>Type</th>
                <th>Value</th>
              </tr>
            </thead>

            <tbody>
              {mapping.map((prop, index) => (
                <tr key={prop.key}>
                  <td className="activity_table_key">{prop.key}</td>
                  <td className="activity_table_select">
                    <select value={prop?.type} onChange={(e) => changeMapType(index, e.target.value)}>
                      <option value="hardcoded">Hard coded</option>
                      <option value="mapped">Mapped</option>
                    </select>
                  </td>
                  <td className="activity_table_value">
                    {prop.type === "mapped" && (
                      <div
                        className="selected_value_items"
                        onClick={() => openModal(index, prop.value)}
                        {...getToolTipAttributes(
                          prop.value && allFieldsObject?.[prop.value]
                            ? `${allFieldsObject[prop.value].prefix || ""}.${allFieldsObject[prop.value].display || ""}`
                            : ""
                        )}
                      >
                        {prop.value === "" ? "select field" : allFieldsObject?.[prop.value]?.display || "Unknown field"}

                        <div>
                          {prop.value && (
                            <MaterialIcon
                              name="delete"
                              className="delete_icon"
                              onClick={(e) => {
                                e.stopPropagation();
                                removeMappedValue(index);
                              }}
                            />
                          )}
                        </div>
                      </div>
                    )}

                    {prop.type === "hardcoded" && (
                      <div className="d_flex justify_between align_center">
                        <Input
                          type="text"
                          value={prop?.value}
                          onChange={(e) => handleChangeMappingValue(index, e.target.value)}
                        />
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <BuilderModal isOpen={modalState.isOpen} onClose={closeModal} modalName={"Select Field"}>
        <TableTreeModal callbackFunction={handleChangeField} tableId={tableId} selectedFile={modalState.fieldId} />
      </BuilderModal>
    </>
  );
};

function filterAndTrimMappingEntries(entries) {
  return entries
    .map((entry) => ({
      ...entry,
      value: entry.value.trim()
    }))
    .filter((entry) => entry.value !== "");
}

export default EditReactComponent;
